module.exports = __webpack_public_path__ + "img/blue.4502f579.png";